import { AxiosInstance } from 'axios'
import { USER_ENDPOINTS } from 'api/ApiRoutes'
import {
  AuthResponse,
  NextActionResponse,
  SLTResponse,
  UserProfile
} from 'types/user'

class EverlanceApi {
  constructor(private axiosInstance: AxiosInstance) {}

  getCurrentUser = async () => {
    const d = await this.axiosInstance.get<UserProfile>(
      USER_ENDPOINTS.CURRENT_USER
    )
    return d.data
  }

  switchSessions = async ({ authToken }: { authToken: string }) => {
    const d = await this.axiosInstance.get<UserProfile>(
      USER_ENDPOINTS.CURRENT_USER,
      {
        headers: {
          Authorization: `Token token=${authToken}`,
          'Content-Type': 'application/json'
        }
      }
    )
    return d.data
  }

  destroySession = async () => {
    const d = await this.axiosInstance.delete(USER_ENDPOINTS.SESSION, {
      baseURL: import.meta.env.VITE_APP_API_BASE_URL.replace('v6', ''),
      headers: {
        'Content-Type': 'application/json'
      }
    })
    return d.data
  }

  samlLogin = async ({ email }: { email: string }) => {
    const params = new URLSearchParams()
    params.append('email', email)
    params.append('dnr', 'true')

    const d = await this.axiosInstance.get<NextActionResponse>(
      USER_ENDPOINTS.SAML_LOGIN,
      {
        baseURL: import.meta.env.VITE_APP_API_BASE_URL.replace('v6', ''),
        params,
        headers: {
          'Content-Type': 'application/json'
        }
      }
    )
    return d.data
  }

  login = async (
    data:
      | {
          email: string
          password: string
          mixpanel_distinct_id?: string
          gt?: string | null
        }
      | { single_login_token: string; mixpanel_distinct_id?: string }
  ) => {
    const d = await this.axiosInstance.post<AuthResponse>(
      USER_ENDPOINTS.LOGIN,
      data
    )
    return d.data
  }

  getSLT = async ({
    tokenId,
    authToken
  }: {
    tokenId: string
    authToken?: string
  }) => {
    const d = await this.axiosInstance.get<SLTResponse>(
      USER_ENDPOINTS.SLT(tokenId),
      {
        headers: {
          Authorization: `Token token=${authToken || ''}`,
          'Content-Type': 'application/json'
        }
      }
    )
    return d.data
  }
}

export default EverlanceApi
